<template>
  <v-card v-if="options && currentUser">
    <BookingPriceTable :booking="booking" :label-colspan="3">
      <template #fund="{ fund }">
        <td>{{ fund.type === "PRECHECK" ? precheckYear : fundYear }}</td>
      </template>
    </BookingPriceTable>

    <v-card-actions>
      <v-dialog v-model="acceptDialog" persistent max-width="600">
        <template #activator="{ on, attrs }">
          <v-btn color="primary" v-bind="attrs" v-on="on">
            {{ $t("user.offer.accept.label") }}
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="headline">
            {{ $t("user.offer.accept.confirmation.title") }}
          </v-card-title>

          <v-card-text>
            <Markdown :value="$t('user.offer.accept.confirmation.description')" />
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="warning" @click="acceptDialog = false">
              {{ $t("user.offer.accept.confirmation.cancel") }}
            </v-btn>

            <v-btn color="primary" @click="accept" :loading="loading">
              {{ $t("user.offer.accept.confirmation.accept") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-btn v-if="booking.offer" :href="booking.offer.url" target="_blank" color="secondary" text class="ml-2">
        <v-icon left>mdi-download</v-icon>
        {{ $t("user.offer.download") }}
      </v-btn>

      <v-spacer></v-spacer>

      <v-dialog v-model="rejectDialog" persistent max-width="600">
        <template #activator="{ on, attrs }">
          <v-btn color="warning" v-bind="attrs" v-on="on">
            {{ $t("user.offer.reject.label") }}
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="headline">
            {{ $t("user.offer.reject.confirmation.title") }}
          </v-card-title>

          <v-card-text>
            {{ $t("user.offer.reject.confirmation.description") }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="warning" @click="rejectDialog = false">
              {{ $t("user.offer.reject.confirmation.cancel") }}
            </v-btn>

            <v-btn color="primary" @click="reject" :loading="loading">
              {{ $t("user.offer.reject.confirmation.accept") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import AcceptBookingMutation from "@/gql/mutations/AcceptBookingMutation.gql";
import RejectBookingMutation from "@/gql/mutations/RejectBookingMutation.gql";
import OptionsQuery from "@/gql/queries/auditor/OptionsQuery.gql";
import BookingsQuery from "@/gql/queries/BookingsQuery.gql";
import BookingPriceTable from "@/components/Booking/BookingPriceTable.vue";

export default {
  components: {
    BookingPriceTable,
  },

  props: {
    booking: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      acceptDialog: false,
      rejectDialog: false,
      loading: false,
      options: null,
      currentUser: null,
    };
  },

  apollo: {
    options: {
      query: OptionsQuery,
      fetchPolicy: "cache-and-network",
    },
    currentUser: {
      query: BookingsQuery,
      fetchPolicy: "cache-and-network",
    },
  },

  computed: {
    fundYear() {
      const redDeadline = new Date(this.options.find((option) => option.key === "redDeadline")?.value);

      return new Date() > redDeadline ? this.booking.year + 1 : this.booking.year;
    },

    precheckYear() {
      const precheckRedDeadline = new Date(this.options.find((option) => option.key === "precheckRedDeadline")?.value);

      return new Date() > precheckRedDeadline ? this.booking.year + 1 : this.booking.year;
    },
  },

  methods: {
    async accept() {
      this.loading = true;

      await this.$apollo.mutate({
        mutation: AcceptBookingMutation,
        variables: {
          id: this.booking.id,
        },
      });

      this.acceptDialog = false;
      this.loading = false;
    },

    async reject() {
      this.loading = true;

      await this.$apollo.mutate({
        mutation: RejectBookingMutation,
        variables: {
          id: this.booking.id,
        },
      });

      this.rejectDialog = false;
      this.loading = false;
    },
  },
};
</script>
